export default __webpack_public_path__ + "static/media/guide08.6141c47a.png";